import React from "react";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useFormikContext } from "formik";

import CostumeButton from "@/component/button";
import SelectionCardGrid from "@/component/selection-card-grid";
import { MedicationForm, TypeMedication } from "@/interfaces/IServiceUser";

export const MEDICATION_TYPES = [
  {
    value: "scheduled",
    label: "Scheduled",
  },
  {
    value: "prn",
    label: "PRN",
  },
  {
    value: "blister-pack",
    label: "Blister Pack",
  },
];

type Props = {
  setSelectedFrequency: (value: string) => void;
  handleNext: () => void;
};

const SelectType = ({ setSelectedFrequency, handleNext }: Props) => {
  const { values, setFieldValue } = useFormikContext<MedicationForm>();

  const handleClick = (value: string) => {
    setFieldValue("type", value);

    if (value === TypeMedication.PRN) {
      setSelectedFrequency("");
      setFieldValue("rrule", {});
      setFieldValue("howManyTimesADay", 0);
      setFieldValue("preferredTime", "");
      setFieldValue("specificTime", []);
      setFieldValue("timePeriod", []);
    }
  };

  return (
    <>
      <SelectionCardGrid>
        {MEDICATION_TYPES.map((item, i) => {
          return (
            <Grid key={i} size={{ xs: 12, sm: 4 }}>
              <CardContent
                className="monitoring"
                onClick={() => handleClick(item.value)}
                sx={[
                  {
                    cursor: "pointer",
                  },
                  values.type === item.value
                    ? {
                        background: "#1F4970 !important",
                      }
                    : {
                        background: "#EAF6FF",
                      },
                  values.type === item.value
                    ? {
                        color: "#FFFFFF !important",
                      }
                    : {
                        color: "#00261C",
                      },
                ]}
              >
                <Box className="weekList">
                  <Typography
                    variant="h6"
                    className="list"
                    sx={[
                      {
                        cursor: "pointer",
                      },
                      values.type === item.value
                        ? {
                            color: "#FFFFFF !important",
                          }
                        : {
                            color: "#00261C",
                          },
                    ]}
                  >
                    {item.label}
                  </Typography>
                </Box>
              </CardContent>
            </Grid>
          );
        })}
      </SelectionCardGrid>
      <Box className="medication-wizard-footer">
        <CostumeButton
          className="invite"
          type="button"
          disabled={!values.type}
          sx={{ width: "98px" }}
          onClick={handleNext}
        >
          Next
        </CostumeButton>
      </Box>
    </>
  );
};

export default SelectType;
